var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHunter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.908,10.007c0,0,6.562,1.328,10.572,5.941c4.012,4.613,3.877,5.039,5.48,9.505    c0.535,1.457,1.604,1.325,2.006,1.257c0.4-0.065,1.604-0.668,0.902-2.739c-0.701-2.074-3.801-13.237-17.66-16.848    c-1.426-0.27-1.953,0.201-2.178,0.853C36.805,8.628,36.971,9.768,37.908,10.007z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.126,10.007c0,0-6.561,1.328-10.572,5.941c-4.011,4.613-3.876,5.039-5.48,9.505    c-0.536,1.457-1.604,1.325-2.006,1.257c-0.401-0.065-1.606-0.668-0.904-2.739c0.702-2.074,3.801-13.237,17.661-16.848    c1.426-0.27,1.952,0.201,2.178,0.853C27.229,8.628,27.064,9.768,26.126,10.007z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.156,53.919c0,0-6.567-1.301-10.598-5.897c-4.03-4.597-3.896-5.023-5.52-9.482    c-0.542-1.454-1.609-1.315-2.01-1.247c-0.401,0.066-1.604,0.674-0.893,2.742c0.711,2.071,3.857,13.221,17.733,16.774    c1.426,0.261,1.949-0.21,2.173-0.861C27.263,55.292,27.094,54.151,26.156,53.919z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.936,53.998c0,0,6.557-1.357,10.549-5.985c3.992-4.632,3.854-5.059,5.439-9.529    c0.529-1.461,1.598-1.332,2.002-1.267c0.402,0.066,1.607,0.661,0.914,2.739c-0.695,2.074-3.746,13.249-17.59,16.918    c-1.424,0.273-1.953-0.191-2.182-0.843S37,54.239,37.936,53.998z",
    fill: "#241F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.189,34.049H35.461c-0.445,0.013-2.207,0.2-2.207,2.413v10.504c0,0,0.047,1.474,1.479,1.179   c6.436-1.082,11.576-5.91,13.141-12.166C48.256,33.977,46.189,34.049,46.189,34.049z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.385,29.938H51.18c-2.672,0-2.824,1.438-2.803,1.905c0,0.053,0.01,0.104,0.01,0.156   c0,0-0.166,2.05,1.891,2.05h12.107c0.887,0,1.604-0.721,1.604-1.604v-0.902C63.988,30.655,63.271,29.938,62.385,29.938z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.695,48.37c-0.168-0.01-0.337-0.019-0.505-0.028l0.008,0.021c0,0-2.056-0.294-2.056,2.589v11.432   c0,0.887,0.719,1.604,1.604,1.604h0.903c0.884,0,1.604-0.718,1.604-1.604V51.503C33.254,49.106,32.305,48.507,31.695,48.37z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.736,34.049h-9.261c-0.586,0.041-1.62,0.354-1.344,1.874c1.388,5.624,5.656,10.103,11.176,11.751   c0.641,0.138,1.835,0.176,1.835-1.46V36.161C29.142,33.955,26.736,34.049,26.736,34.049z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.617,31.931c-0.016-0.489-0.238-1.993-2.444-1.993H1.616c-0.887,0-1.604,0.718-1.604,1.604v0.902   c0,0.884,0.718,1.604,1.604,1.604h11.808c2.139,0,2.212-1.551,2.195-1.952c0-0.031-0.006-0.062-0.006-0.098   C15.612,31.978,15.617,31.955,15.617,31.931z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.791,27.726c-1.572-5.826-6.264-10.357-12.18-11.689c-2.416-0.573-2.357,1.824-2.357,1.824v9.927   c0,0-0.049,2.15,2.182,2.15h10.529C45.965,29.938,48.354,29.94,47.791,27.726z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.82,16.472c-5.045,1.68-8.995,5.738-10.515,10.855c-0.001,0.006-0.647,2.61,1.606,2.61h8.612   c0.742-0.025,2.62-0.329,2.62-2.852v-8.925C29.142,15.977,27.08,16.406,26.82,16.472z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.649,0.012h-0.903c-0.885,0-1.604,0.718-1.604,1.604v11.682c0,0-0.053,2.457,2.179,2.331   c0.067-0.003,0.102,0.007,0.162,0.007c0.013,0,0.021,0,0.035,0c0.056,0,0.11-0.007,0.166-0.007c0.56-0.047,1.57-0.357,1.57-2.029   V1.616C33.254,0.729,32.534,0.012,31.649,0.012z",
    fill: "#241F20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunter);
export default __webpack_public_path__ + "static/media/hunter.d20869a9602800abeed2bd1ea3cef2bb.svg";
export { ForwardRef as ReactComponent };